
import { AddCircle } from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import { IconButton, TextareaAutosize } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import LoadingButton from '@mui/lab/LoadingButton';
import { Checkbox, FormControlLabel, TextField } from "@mui/material";

const Notes = (props) => {
    const [notes, setNotes] = useState(props.notes)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        setNotes(props.notes || [])
    },[props.notes])

    const addEmptyNoteForm = () => {
        let currentNotes= Object.assign([], notes);
        if (notes && !notes.find(n => n.new)) {
            currentNotes.push({
                new: true
            })
            setNotes(currentNotes)
        }
    }

    const setTitle = (value) => {
        let currentNotes= Object.assign([], notes);
        let newNote = currentNotes.find(n => n.new);
        newNote.title = value;
        setNotes(currentNotes);
    }

    const setDescription = (value) => {
        let currentNotes= Object.assign([], notes);
        let newNote = currentNotes.find(n => n.new);
        newNote.body = value;
        setNotes(currentNotes);
    }

    const setRequiresFollowup = (value) => {
        let currentNotes= Object.assign([], notes);
        let newNote = currentNotes.find(n => n.new);
        newNote.requires_followup = value;
        setNotes(currentNotes);
    }

    const handleSubmit = () => {
        let currentNotes= Object.assign([], notes);
        let newNote = currentNotes.find(n => n.new);

        setIsSubmitting(true);
        props.onSubmit(newNote).then(response => {
            setIsSubmitting(false);
        })
    }

    return (
        <div className="notes">
            <div className="space-add-mode">  
                { notes && notes.length > 0 ?
                    <Tooltip title="Add a New Note">   
                        <IconButton 
                                    variant="contained" 
                                    color="primary"
                                    aria-label={"Add a note" }

                                    onClick={() => {
                                        addEmptyNoteForm()
                                }}>
                                <AddCircle style={{fill: "#00b088", background: "white", transform: "scale(1.0)"}}/>
                        </IconButton>
                    </Tooltip>
                : null}
            </div>
            <div className="section-header">
                Notes
            </div>
                { notes && notes.length > 0 ? (
                    <div className="notes-container">
                    { notes.map(n => {
                        let className = n.requires_followup ? "note followup" : "note"
                        return n.new ?
                            <div key={n.id} className="note new">
                                <div className="note-edit-field">
                                    <TextField label="Title" variant="outlined" size="small" onChange={(e) => {setTitle(e.target.value)}} required/>
                                </div>
                                <div className="note-edit-field">
                                    <TextField multiline fullWidth rows={2} label="Enter note here." variant="outlined" size="small" onChange={(e) => {setDescription(e.target.value)}} required/>
                                </div>
                                <div className="note-edit-field">
                                    <FormControlLabel control={<Checkbox onChange={(e) => {setRequiresFollowup(e.target.checked)}} />} label="Requires Followup?" />
                                </div>
                                <div className="note-edit-button">
                                    <LoadingButton variant="contained" loading={isSubmitting} onClick={handleSubmit} style={{backgroundColor: "#003e51"}}>Submit</LoadingButton>
                                </div>
                            </div>
                            :
                                <div key={n.id} className={className}>
                                    <div className="note-title">{n.title}</div>
                                    <div className="note-body">{n.body}</div>
                                    <div className="note-author">{n.author}</div>
                            </div>
                    }) 
                    }
                </div>
                )
                :
                <div className="bulk-add-prompt">
                    <IconButton 
                                    variant="contained" 
                                    color="primary"
                                    aria-label={"Add file" }

                                    onClick={() => {
                                        addEmptyNoteForm()
                                }}>
                            <AddCircle style={{fill: "#00b088", background: "white"}}/>
                    </IconButton>
                    There are currently no notes.  Add one now!
                </div>
                }
            

        </div>
    )
}

export default Notes;